import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import localization from '../../../../shared/strings';
import { draftScopeDialogStyles as draftScopeStyles } from '../../../DraftScopeDialogChrome';
import RadioItem from '../../../RadioItem';
import { MEDIA_SYNC_MODE } from '../helpers/syncFlowOrchestrator';
import s from './styles.module.scss';

function MediaModeToggle({ mediaMode, disabled, onChange, addTestId, replaceTestId }) {
  const scopeStrings = localization.DIALOGS.PRODUCT_DIALOGS.CONNECT_CHANNEL.PUBLISHING_SCOPE;

  const handleSelectAdd = () => {
    if (disabled) return;
    onChange(MEDIA_SYNC_MODE.ADD);
  };

  const handleSelectReplace = () => {
    if (disabled) return;
    onChange(MEDIA_SYNC_MODE.REPLACE);
  };

  return (
    <div
      className={cn(draftScopeStyles.sourceToggle, s.mediaModeToggle)}
      role="radiogroup"
      aria-label={scopeStrings.MEDIA_ATTRIBUTES_TITLE}
    >
      <div
        className={cn(draftScopeStyles.sourceOption, {
          [draftScopeStyles.sourceOptionSelected]: mediaMode === MEDIA_SYNC_MODE.ADD,
        })}
        role="radio"
        aria-checked={mediaMode === MEDIA_SYNC_MODE.ADD}
        data-testid={addTestId}
        onClick={handleSelectAdd}
      >
        <RadioItem
          value={MEDIA_SYNC_MODE.ADD}
          checkedValue={mediaMode}
          disabled={disabled}
          onChange={onChange}
          aria-label={scopeStrings.ADD_MEDIA_TITLE}
        />
        <div className={draftScopeStyles.sourceOptionCopy}>
          <div className={draftScopeStyles.sourceOptionTitle}>
            {scopeStrings.ADD_MEDIA_TITLE}
          </div>
          <div className={draftScopeStyles.sourceOptionDescription}>
            {scopeStrings.ADD_MEDIA_DESCRIPTION}
          </div>
        </div>
      </div>
      <div
        className={cn(draftScopeStyles.sourceOption, {
          [draftScopeStyles.sourceOptionSelected]: mediaMode === MEDIA_SYNC_MODE.REPLACE,
        })}
        role="radio"
        aria-checked={mediaMode === MEDIA_SYNC_MODE.REPLACE}
        data-testid={replaceTestId}
        onClick={handleSelectReplace}
      >
        <RadioItem
          value={MEDIA_SYNC_MODE.REPLACE}
          checkedValue={mediaMode}
          disabled={disabled}
          onChange={onChange}
          aria-label={scopeStrings.REPLACE_MEDIA_TITLE}
        />
        <div className={draftScopeStyles.sourceOptionCopy}>
          <div className={draftScopeStyles.sourceOptionTitle}>
            {scopeStrings.REPLACE_MEDIA_TITLE}
          </div>
          <div className={draftScopeStyles.sourceOptionDescription}>
            {scopeStrings.REPLACE_MEDIA_DESCRIPTION}
          </div>
        </div>
      </div>
    </div>
  );
}

MediaModeToggle.propTypes = {
  mediaMode: PropTypes.oneOf([MEDIA_SYNC_MODE.ADD, MEDIA_SYNC_MODE.REPLACE]).isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  addTestId: PropTypes.string,
  replaceTestId: PropTypes.string,
};

MediaModeToggle.defaultProps = {
  disabled: false,
  addTestId: 'publishing-scope-media-add',
  replaceTestId: 'publishing-scope-media-replace',
};

export default MediaModeToggle;
